// extracted by mini-css-extract-plugin
module.exports = {"unselectedGray":"styles_unselectedGray__7cp6H","selectedGray":"styles_selectedGray__MXej4","unselectedRed":"styles_unselectedRed__9nREJ","selectedRed":"styles_selectedRed__rkV_q"};